export const fieldTypes = {
    Text: "Text", 
    Email: "Email", 
    Phone: "Phone", 
	TextArea: "TextArea",
	Switch: "Switch", 
	Picture: "Picture",
	Signature: "Signature",
	Number: "Number", 
	DateTime: "DateTime", 
	Time: "Time", 
	Date: "Date",
    Dropdown: "Dropdown",
    Checkbox: "Checkbox"
}

export const fields = [
    {
        id: `${fieldTypes.Text}1`,
        type: fieldTypes.Text,
        label: "Text",
        required: true,
        readOnly: false,
        placeHolder: "This is a input text placeholder",
        help: "",
        attributes: {
            maxLength: 100,
            default: ""
        },
        uiConfiguration: {
            icon: "text_fields",
            name: "dynamicFormsDesign_textField",
            description: "dynamicFormsDesign_textFieldHelp"
        }
    },
    {
        id: `${fieldTypes.TextArea}1`,
        type: fieldTypes.TextArea,
        label: "Text area",
        required: true,
        readOnly: false,
        placeHolder: "This is a text area placeholder",
        help: "",
        attributes: {
            maxLength: 100,
            default: ""
        },
        uiConfiguration: {
            icon: "note",
            name: "dynamicFormsDesign_textArea",
            description: "dynamicFormsDesign_textAreaHelp"
        }
    },
    {
        id: `${fieldTypes.Email}1`,
        type: fieldTypes.Email,
        label: "Email",
        required: true,
        readOnly: false,
        placeHolder: "This is a email placeholder",
        help: "",
        attributes: {
            maxLength: 100,
            default: ""
        },
        uiConfiguration: {
            icon: "alternate_email",
            name: "dynamicFormsDesign_email",
            description: "dynamicFormsDesign_emailHelp"
        }
    },
    {
        id: `${fieldTypes.Switch}1`,
        type: fieldTypes.Switch,
        label: "Switch",
        required: true,
        readOnly: false,
        placeHolder: "This is a input switch placeholder",
        help: "",
        attributes: {
            offLabel: "Off",
            onLabel: "On"
        },
        uiConfiguration: {
            icon: "toggle_on",
            name: "dynamicFormsDesign_switch",
            description: "dynamicFormsDesign_switchHelp"
        }
    },
    {
        id: `${fieldTypes.Picture}1`,
        type: fieldTypes.Picture,
        label: "Picture",
        required: true,
        readOnly: false,
        placeHolder: "This is a input picture placeholder",
        help: "",
        attributes: {
            allowGallery: true
        },
        uiConfiguration: {
            icon: "collections",
            name: "dynamicFormsDesign_picture",
            description: "dynamicFormsDesign_pictureHelp"
        },
        permission: "photoup"
    },
    {
        id: `${fieldTypes.Signature}1`,
        type: fieldTypes.Signature,
        label: "Signature",
        required: true,
        readOnly: false,
        placeHolder: "This is a input signature placeholder",
        help: "",
        attributes: {
            allowGallery: true
        },
        uiConfiguration: {
            icon: "draw",
            name: "dynamicFormsDesign_signature",
            description: "dynamicFormsDesign_signatureHelp"
        },
        permission: "sigcap"
    },
    {
        id: `${fieldTypes.Number}1`,
        type: fieldTypes.Number,
        label: "Number",
        required: true,
        readOnly: false,
        placeHolder: "This is a input number placeholder",
        help: "",
        attributes: {
            default: null,
            maxLength: 10,
        },
        uiConfiguration: {
            icon: "numbers",
            name: "dynamicFormsDesign_number",
            description: "dynamicFormsDesign_numberHelp"
        }
    },
    {
        id: `${fieldTypes.Phone}1`,
        type: fieldTypes.Phone,
        label: "Phone",
        required: true,
        readOnly: false,
        placeHolder: "This is a input phone placeholder",
        help: "",
        attributes: {
            default: null,
            minimum: null,
            maximum: null  
        },
        uiConfiguration: {
            icon: "local_phone",
            name: "dynamicFormsDesign_phone",
            description: "dynamicFormsDesign_phoneHelp"
        }
    },
    {
        id: `${fieldTypes.DateTime}1`,
        type: fieldTypes.DateTime,
        label: "Date time",
        required: true,
        readOnly: false,
        placeHolder: "This is a input date time placeholder",
        help: "",
        attributes: {
            default: null,
            minimum: null,
            maximum: null  
        },
        uiConfiguration: {
            icon: "event_available",
            name: "dynamicFormsDesign_datetime",
            description: "dynamicFormsDesign_datetimeHelp"
        }
    },
    {
        id: `${fieldTypes.Date}1`,
        type: fieldTypes.Date,
        label: "Date",
        required: true,
        readOnly: false,
        placeHolder: "This is a input date placeholder",
        help: "",
        attributes: {
            default: null,
            minimum: null,
            maximum: null  
        },
        uiConfiguration: {
            icon: "calendar_month",
            name: "dynamicFormsDesign_date",
            description: "dynamicFormsDesign_dateHelp"
        }
    },
    {
        id: `${fieldTypes.Time}1`,
        type: fieldTypes.Time,
        label: "Time",
        required: true,
        readOnly: false,
        placeHolder: "This is a input time placeholder",
        help: "",
        attributes: {
            default: null,
            minimum: null,
            maximum: null  
        },
        uiConfiguration: {
            icon: "access_time",
            name: "dynamicFormsDesign_time",
            description: "dynamicFormsDesign_timeHelp"
        }
    },
    {
        id: `${fieldTypes.Dropdown}1`,
        type: fieldTypes.Dropdown,
        label: "Dropdown",
        required: true,
        readOnly: false,
        placeHolder: "This is a input dropdown placeholder",
        help: "",
        attributes: {
            default: null,
            options: []
        },
        uiConfiguration: {
            icon: "arrow_drop_down",
            name: "dynamicFormsDesign_dropdown",
            description: "dynamicFormsDesign_dropdownHelp"
        }
    },
    {
        id: `${fieldTypes.Checkbox}1`,
        type: fieldTypes.Checkbox,
        label: "Checkbox",
        required: true,
        readOnly: false,
        placeHolder: "This is a input checkbox placeholder",
        help: "",
        attributes: {
            default: null,
            options: []
        },
        uiConfiguration: {
            icon: "check_box",
            name: "dynamicFormsDesign_checkbox",
            description: "dynamicFormsDesign_checkboxHelp"
        }
    },
];